"use strict";
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlateConverter = void 0;
const BlockConverter_1 = require("./BlockConverter");
class PlateConverter {
    /* -------------------------------------------------- */
    /*                     Conversion                     */
    /* -------------------------------------------------- */
    static toSnapshot(backendPlate, currentUserId) {
        const snapshot = {
            ...this.toBaseSnapshot(backendPlate, currentUserId),
            likes: backendPlate.likedBy || [],
            height: backendPlate.height,
            width: backendPlate.width,
            selection: [],
            initialBlockSnapshots: (backendPlate.blocks || []).map((block) => BlockConverter_1.BlockConverter.toSnapshot(block, currentUserId)),
            blockIds: (backendPlate.blocks || []).map((block) => block.id),
            initialEditors: backendPlate.Permission?.editors || [],
            editorIds: (backendPlate.Permission?.editors || []).map((editor) => editor.id),
            modal: null,
        };
        return snapshot;
    }
    static toBaseSnapshot(backendPlate, currentUserId) {
        const snapshot = {
            id: backendPlate.id,
            title: backendPlate.title,
            createdAt: backendPlate.createdAt.toString(),
            updatedAt: backendPlate.updatedAt.toString(),
            screenshotTime: backendPlate.screenshotTime?.toString() || null,
            owner: backendPlate.user,
            currentUserIsOwner: backendPlate.user.id === currentUserId,
            // initialEditors: backendPlate.Permission?.editors || [], // much like blocks, these will be pulled off and turned into classes when the plate is instantiated
            editable: this.getIsEditable(backendPlate.Permission || null, currentUserId),
            isPublic: backendPlate.isPublic,
            isLiked: this.getIsLiked(backendPlate.likedBy || [], currentUserId),
        };
        return snapshot;
    }
    /* -------------------------------------------------- */
    /*                       Helpers                      */
    /* -------------------------------------------------- */
    static getIsEditable(permission, currentUserId) {
        if (!currentUserId)
            return false;
        if (permission?.ownerId === currentUserId)
            return true; // true if owner
        if (permission?.editors?.some((editor) => editor.id === currentUserId))
            return true; // true if editor
        return false;
    }
    static getIsLiked(likes, currentUserId) {
        if (!currentUserId)
            return false;
        return likes.some((like) => like.userId === currentUserId);
    }
}
exports.PlateConverter = PlateConverter;
//# sourceMappingURL=PlateConverter.js.map